<template>
  <div class="profile-image">
    <div class="profile-image__container" @click="handleClick(!showModal)">
      <img :src="image" alt="profile image" v-if="image" />
      <img alt="profile image" :src="avatarPlaceholder" v-else />
    </div>
    <ProfileImageUploader
      v-if="showModal"
      @close="handleClick"
      @response="handleResponse"
      :current="image"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "@/helpers/axios";
import ProfileImageUploader from "@/components/profile-image/ProfileImageUploader";
import * as logger from "@/helpers/logger";

export default {
  props: {
    image: {
      type: String,
      default: ""
    }
  },
  components: {
    ProfileImageUploader
  },
  data: () => ({
    showModal: false,
    avatarPlaceholder: require("@/assets/media/avatars/avatar0.jpg")
  }),
  methods: {
    ...mapActions({
      AUTH_SET_COOKIE: "AUTH_SET_COOKIE"
    }),
    ...mapGetters({
      getUser: "getUser"
    }),
    handleClick(flag) {
      this.showModal = flag;
    },
    handleResponse(images) {
      const id = this.getUser().id;
      const url = images[0].location.replace(images[0].id, "original");
      var user = JSON.parse(JSON.stringify(this.getUser()));
      user.avatar = url;
      this.AUTH_SET_COOKIE(user);
      axios
        .patch(`/users/${id}`, {
          avatar: url
        })
        .then(() => {
          this.$swal("Success", "Successfully saved", "success");
          this.handleClick(false);
        })
        .catch(error => {
          logger.error(error);
          this.$swal("Warning", "Something happened", "warning");
          this.handleClick(false);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.profile-image {
  &__container {
    background-color: $gray-400;
    overflow: hidden;
    height: 160px;
    width: 160px;
    border-radius: 90px;
    position: relative;
    img {
      height: 160px;
      width: 100%;
      object-fit: cover;
    }
    &::after {
      background-color: #242424;
      content: "Upload";
      display: block;
      height: 160px;
      opacity: 0;
      width: 160px;
      z-index: 900;
      position: absolute;
      top: 0;
      left: 0;
      padding-top: 100px;
      color: white;
      cursor: pointer;
      text-align: center;
      transition: opacity 0.2s ease-in;
    }
    &:hover {
      &::after {
        opacity: 0.9;
      }
    }
  }
}
</style>
